import ApiClient from '@/plugins/AxiosPlugin'
import OrderManagementDTOService from '@/dow-platform/components/commerce/myAccount/helper/order-management-dto-service'
import DeliveryFiltersDefaultValueHelper from '@/dow-platform/components/commerce/myAccount/helper/filter-helpers/delivery-filters-default-value-helper'

export const orderManagementExportOptions = {
    namespaced: true,
    modules: {
        order: {
            namespaced: true,
            state: {
                exportResource: 'exportOrderDetail',
                isOrder: true,
                exportOptions: [],
                hasExportError: false
            }
        },
        delivery: {
            namespaced: true,
            state: {
                exportResource: 'exportDeliveryDetail',
                isOrder: false,
                exportOptions: [],
                hasExportError: false
            }
        }, 
        coa: {
            namespaced: true,
            state: {
                exportResource: 'exportCoaDetail',
                isOrder: false,
                exportOptions: [],
                hasExportError: false
            }
        }
    },
    mutations: {
        setExportOptions: function (state, payload) {
            const subModule = payload.subModule
            const exportOptions = payload.exportOptions
            state[subModule].exportOptions = exportOptions
        },
        setHasExportError: function (state, payload) {
            const subModule = payload.subModule
            const value = payload.value
            state[subModule].hasExportError = value
        }
    },
    actions: {
        exportItems: function (context, config) {
            exportItems(
                context,
                config.subModule,
                config.opts,
                config.saveDefault
            )
        }
    }
}

function exportItems(context, subModule, opts, saveDefault) {
    const activeFilters =
        context.rootGetters[`myAccountItems/activeFilters`](subModule)
    const isCustomDateRange =
        context.rootGetters['myAccountItems/isCustomDateRange'](subModule)
    activeFilters.fromSubModule = subModule
    const filters =
        OrderManagementDTOService.getOrderManagementFilterDTO(activeFilters)
    filters.toDate =
        subModule === 'delivery' && !isCustomDateRange
            ? DeliveryFiltersDefaultValueHelper.getDefaultDeliveryToDate()
            : filters.toDate
    const filtersJson = JSON.stringify(filters)
    const exportResource = context.state[subModule].exportResource
    const isOrder = context.state[subModule].isOrder
    const url = context.rootState.settings.export_data
    const exportItemsData = isOrder ? context.rootState.myAccountItems.order.items : context.rootState.myAccountItems.delivery.items;
    const numbers = exportItemsData.map(exportItemsData => exportItemsData.orderNumber || exportItemsData.deliveryNumber); 
    context.commit('loading/setLoading', true, { root: true })
    context.state[subModule].hasExportError = false
    //build form data for submission
    var formData = new FormData()
    formData.append('filters', filtersJson)
    formData.append('exportNumbers', JSON.stringify(numbers))
    formData.append('isOrder', isOrder)
    formData.append('saveDefault', saveDefault)
    if (opts) {
        formData.append('exportKeys', opts)
    }
    ApiClient.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((res) => {
            const data = res.data
            const url = window.URL.createObjectURL(new Blob([convertToUTF16(data)],{ type: 'text/csv;charset=UTF-16LE' }));
            const link = document.createElement('a');
            link.href = url;
            const filename = res.headers['content-disposition']
                             ? /filename="([^"]+)"/.exec(res.headers['content-disposition'])[1]
                             : 'downloaded-file';
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            context.commit('loading/setLoading', false, { root: true })
        })
        .catch(function (error) {
            const errorData = error.data
            handleExportError(context, subModule, errorData)
            context.commit('loading/setLoading', false, { root: true })
        })
}

function convertToUTF16(str) {
    const buf = new Uint8Array(2 + str.length * 2);
    buf[0] = 0xFF; buf[1] = 0xFE;
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        buf[2 + i * 2] = code & 0xFF;
        buf[2 + i * 2 + 1] = code >> 8;
    }
    return buf;
}
